
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 30","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M19.18 13.32V15c0 .208-.04.417-.117.625l-2.54 5.86c-.26.677-.768 1.015-1.523 1.015H7.5c-.443 0-.833-.17-1.172-.508-.338-.338-.508-.729-.508-1.172V12.5c0-.443.17-.833.508-1.172l5.469-5.508.898.899c.235.234.352.52.352.86v.273l-.82 3.828H17.5c.443 0 .833.169 1.172.508.338.312.508.69.508 1.132zM.82 22.5v-10h3.36v10H.82z"}})])
          )
        }
      }
    